var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-twitter-original';
                    var viewUrl = 'gfx/sprite.svg#view-icon-twitter-original';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 400 400',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };